<template>
    <Modal
        class="recharge"
        v-model="props.isShowModel"
        :closable="false"
        loading
        :mask-closable="false"
        width="878"
        :draggable="true"
        :sticky="true">
        <template #header>
            <div></div>
        </template>
        <div class="content">
            <div class="close" @click="close">
                <img src="@/assets/close.png" alt="" />
            </div>
            <div class="top">
                <!-- You've reached the limit of 3 documents — time to upgrade! -->
                 {{ rechargeText }}
            </div>
            <div class="center">
                <div class="center-upgrade">
                    <div class="left">
                        <img src="@/assets/upgrade.png" alt="">
                        Upgrade to Pro or Premium to unlock full access
                    </div>
                    <div class="right" @click="toPrice">Upgrade</div>
                </div>
                <div class="upgrade-list">
                    <div class="item">
                        <img src="@/assets/credit-card.png" alt="">
                        Unlimited document uploads
                    </div>
                    <div class="item">
                        <img src="@/assets/credit-card.png" alt="">
                        No page limits
                    </div>
                    <div class="item">
                        <img src="@/assets/credit-card.png" alt="">
                        Customize your AVATAR
                    </div>
                    <div class="item">
                        <img src="@/assets/credit-card.png" alt="">
                        Access advanced AI features
                    </div>
                    <div class="item">
                        <img src="@/assets/credit-card.png" alt="">
                        And get our full support
                    </div>
                </div>
            </div>
            <!-- <div class="bottom">
                🎁Subscribe before May 31st and get an extra <span>30% off!</span>🥳
            </div> -->
        </div>
        <template #footer>
            <div class="footer-btn"></div>
        </template>
    </Modal>
</template>

<script setup>
import { ref, getCurrentInstance, computed,watch } from "vue";

import {
    rechargeURL
} from "@/api/config";
const { proxy } = getCurrentInstance();
import { useStore } from "vuex";
const store = useStore();
import { useRoute, useRouter } from "vue-router";
const router = useRouter();
const props = defineProps({
    isShowModel: Boolean,
});
const rechargeText = computed(() => store.state.user.rechargeText);
const close = () => {
    store.dispatch("user/set_recharge", {recharge:false}); //提示充值
};

const toPrice = () => {
    store.dispatch("user/set_recharge", {recharge:false}); //提示充值
    // router.push('/price')
    window.open(`${rechargeURL()}/price`, '_blank' )
};

watch(()=>props.isShowModel,(newValue)=>{
    if(newValue) {
        proxy.$creatLoading.hide();
        proxy.$loading.hide();
        proxy.$playLoading.hide();
    }
})


</script>

<style lang="less">
.recharge {
    .ivu-modal-content {
        border-radius: 20px !important;
        width: 878px;
        height: 464px;
    }
    &.ivu-modal-fullscreen {
        width: 90% !important;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
        .ivu-modal-content {
            border-radius: 20px !important;
            height: 400px;
        }
    }
}
</style>

<style lang="less" scoped>
.content {
    padding: 0 70px;
    display: flex;
    flex-direction: column;
    height: 50px;
    position: relative;

    .close {
        position: absolute;
        top: -30px;
        right: 0px;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px 4px 4px 4px;
        cursor: pointer;

        &:hover {
            background: rgba(239, 239, 239, 1);
        }

        img {
            width: 16px;
            height: 16px;
        }
    }

    .top {
        font-size: 20px;
        font-weight: 500;
        color: rgba(49, 48, 46, 1);
        text-align: center;
    }
    .center {
        margin-top: 24px;
        .center-upgrade {
            height: 60px;
            background: rgba(73, 69, 255, 0.1);
            padding: 0 24px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 8px 8px 0px 0px;
            .left {
                color: rgba(49, 48, 46, 1);
                font-weight: 400;
                font-size: 16px;
                display: flex;
                align-items: center;
                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }
            }
            .right {
                font-size: 14px;
                font-weight: 600;
                background: #4945ff;
                border-radius: 8px 8px 8px 8px;
                height: 32px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 88px;
                cursor: pointer;
                &:hover {
                    background:rgba(73, 69, 255, .7)
                }
            }
        }
        .upgrade-list {
            height: 188px;
            background: rgba(236, 236, 255, 0.20);
            padding-left: 240px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-top: 20px;
            padding-bottom: 20px;
            border-radius: 0px 0px 8px 8px;
            .item {
                color:rgba(49, 48, 46, 1) ;
                font-size: 16px;
                font-weight: 400;
                display: flex;
                align-items: center;
                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 4px;
                }
            }
        }
    }

    .bottom {
        text-align: center;
        font-size: 22px;
        font-weight: 900;
        color: rgba(49, 48, 46, 1);
        margin-top: 24px;
        span {
            color: rgba(73, 69, 255, 1);
        }
    }
}

.footer-btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;

    .y-btn {
        width: 80px;
        line-height: 40px;
        text-align: center;
        height: 40px;
        font-weight: 500;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        margin-left: 14px;
        cursor: pointer;
    }

    .cancel {
        border: 1px solid rgba(141, 141, 168, 0.4);
        color: rgba(49, 48, 46, 1);

        &:hover {
            background: rgba(245, 246, 248, 1);
        }
    }

    .ok {
        background: #4945ff;
        color: #fff;

        &:hover {
            background: rgba(104, 100, 255, 1);
        }
    }
}
</style>
